import { collection, doc, getDocs, onSnapshot, query } from "firebase/firestore";
import { getFirebaseWebFirestore } from "./firebaseWeb";
import { HEX_SKILL_NODES } from "../data/SkillTree";

const TITLE_COLLECTION = "traitDefinitions";
const HEX_SKILL_COLLECTION = "hexSkillDefinitions";
const PROFILE_COLLECTION = "webUserProfiles";

function number(value) {
  const parsed = Number(value || 0);
  return Number.isFinite(parsed) ? Math.round(parsed) : 0;
}

function effects(source = {}) {
  return { xp: number(source.xp), hype: number(source.hype), denk: number(source.denk), trustScore: number(source.trustScore) };
}

function normalizeTitle(row = {}) {
  const id = String(row.id || "").trim();
  const label = String(row.name || row.label || "").trim();
  return {
    ...row,
    id,
    key: id.replace(/^title-/, ""),
    label,
    reason: String(row.description || "").trim(),
    minLevel: Math.max(1, number(row.level) || 1),
    effects: effects(row.effects),
  };
}

function normalizeHexSkill(row = {}) {
  const id = String(row.id || "").trim();
  const label = String(row.label || row.name || row.value || id).trim();
  return {
    ...row,
    id,
    label,
    value: String(row.value || label).trim(),
    category: String(row.category || "").trim(),
    type: String(row.type || "trait").trim(),
    tier: Math.max(0, number(row.tier)),
    parents: Array.isArray(row.parents) ? row.parents.map(String) : [],
    effects: effects(row.effects),
  };
}

export async function listTitleCatalog() {
  try {
    const snapshot = await getDocs(query(collection(getFirebaseWebFirestore(), TITLE_COLLECTION)));
    return snapshot.docs
      .map((item) => normalizeTitle({ id: item.id, ...(item.data() || {}) }))
      .filter((item) => item.id && item.label && item.kind === "title" && item.active !== false)
      .sort((a, b) => a.label.localeCompare(b.label, "tr"));
  } catch {
    return [];
  }
}

export async function listHexSkillCatalog() {
  try {
    const snapshot = await getDocs(query(collection(getFirebaseWebFirestore(), HEX_SKILL_COLLECTION)));
    const rows = snapshot.docs
      .map((item) => normalizeHexSkill({ id: item.id, ...(item.data() || {}) }))
      .filter((item) => item.id && item.label && item.active !== false);
    return rows.length ? rows : HEX_SKILL_NODES.map(normalizeHexSkill);
  } catch {
    return HEX_SKILL_NODES.map(normalizeHexSkill);
  }
}

export function subscribeUserEconomy(uid, onValue, onError = () => {}) {
  if (!uid) return () => {};
  const db = getFirebaseWebFirestore();
  return onSnapshot(
    doc(db, PROFILE_COLLECTION, uid),
    (snapshot) => {
      const data = snapshot.data() || {};
      onValue({ xp: number(data.xp ?? data.totalXp), hype: number(data.hype), denk: number(data.denk) });
    },
    onError,
  );
}
